import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-edit-roaming-community-member',
  templateUrl: './edit-roaming-community-member.component.html',
})
export class EditRoamingCommunityMemberComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
